// Add your JS customizations here
jQuery(document).ready(function($) {
	new WOW().init();

	jQuery(function ($) {
		$('#input_2_4').select2();
		$('#archives-dropdown-2').select2();
		$('#cat').select2();
	});

	function applyMenuPadding() {
		// Select only visible menu containers (ignores hidden ones like .d-none)
		var $menu = $('.menu-container:visible');
		if (!$menu.length) return;

		// Get menu height
		var menuHeight = $menu.outerHeight();

		// Apply padding-top to any element with this class
		$('.menu-spacer-padding').each(function() {
			var $el = $(this);

			// Get extra padding from data attribute (default 25)
			var extra = parseInt($el.data('extra-padding')) || 25;

			// Set padding-top
			$el.css('padding-top', (menuHeight + extra) + 'px');
		});
	}

	// Run on page load
	$(document).ready(function() {
		applyMenuPadding();
	});

	// Recalculate on window resize and orientation change
	$(window).on('resize orientationchange', function() {
		applyMenuPadding();
	});

	function updateDropdownPosition() {
		var headerHeight = $('.menu-container').outerHeight();
		$('.header-dropdown-wrapper').css('top', headerHeight + 'px');
	}

	function checkScroll() {
		if ($(window).scrollTop() > 50) {
			$('#wrapper-navbar').addClass('scroll-active');
		} else {
			$('#wrapper-navbar').removeClass('scroll-active');
		}

		// Update dropdown position whenever scroll-active toggles
		updateDropdownPosition();
	}

	$(document).ready(function() {
		// Run on load
		updateDropdownPosition();
		checkScroll();

		// Run on scroll (in case header changes height dynamically)
		$(window).on('scroll resize', function() {
			checkScroll();
			updateDropdownPosition();
		});
	});

	// Menu Triggers
	// Open dropdown on hover
	$(document).on('mouseenter', '.trigger', function () {
		const $this = $(this);
		const triggerClass = $this.attr('class').split(' ').find(c => c.startsWith('trigger-'));

		if (!triggerClass) return;

		const targetClass = triggerClass.replace('trigger-', '');
		openDropdown(targetClass, triggerClass);
	});

	// Close dropdown when leaving BOTH trigger + dropdown
	$(document).on('mouseleave', '.trigger, .header-dropdown-wrapper', function () {
		// Add slight delay to avoid flicker when moving between trigger and dropdown
		setTimeout(() => {
			if (
				!$('.trigger:hover').length &&
				!$('.header-dropdown-wrapper:hover').length
			) {
				closeAllDropdowns();
			}
		}, 150);
	});

	function openDropdown(targetClass, triggerClass) {
		const $targetDropdown = $('.header-dropdown-wrapper .dropdown-item.' + targetClass);

		closeAllDropdowns();
		$targetDropdown.addClass('active');

		// Highlight ALL triggers with same class
		$('.trigger.' + triggerClass).addClass('menu-active');
	}

	function closeAllDropdowns() {
		$('.header-dropdown-wrapper .dropdown-item').removeClass('active');
		$('.trigger').removeClass('menu-active');
	}

	// === Universal Equal Height Function ===
	function setEqualHeights(wrapperSelector) {
		$(wrapperSelector).find('.split-section-row').each(function() {
			var $row = $(this);
			var $text = $row.find('.text-content');
			var $image = $row.find('.image-content');
			var $line = $row.find('.line-container');

			// Reset heights first
			$image.css('height', 'auto');
			$line.css('height', 'auto');

			// Get text-content height
			var textHeight = $text.outerHeight();

			// Apply same height to image and line
			$image.css('height', textHeight + 'px');
			$line.css('height', textHeight + 'px');
		});
	}

	// === Universal Dot Position Function ===
	function updateDotPosition(wrapperSelector) {
		$(wrapperSelector).each(function() {
			var $wrapper = $(this);
			var $line = $wrapper.find('.inner-line');
			var $dot = $wrapper.find('.inner-dot');

			if (!$line.length || !$dot.length) return;

			var scrollTop = $(window).scrollTop();
			var windowHeight = $(window).height();
			var wrapperTop = $wrapper.offset().top;
			var wrapperHeight = $wrapper.outerHeight();

			var lineHeight = $line.height();
			var dotHeight = $dot.outerHeight();

			var bottomOffsetPx = (dotHeight / 2) - 12;
			var maxTop = Math.max(0, lineHeight - dotHeight - bottomOffsetPx);

			// Center the dot slightly higher (e.g., 100px above middle)
			var offset = -75;
			var progress = (scrollTop + windowHeight / 2 + offset - wrapperTop) / wrapperHeight;
			progress = Math.min(Math.max(progress, 0), 1);

			var topPosition = Math.round(progress * maxTop);
			$dot.css('top', topPosition + 'px');
		});
	}

	// === Run for both sections independently ===
	setEqualHeights('.how-it-works-wrapper');
	setEqualHeights('.team-section-wrapper');
	updateDotPosition('.how-it-works-wrapper');
	updateDotPosition('.team-section-wrapper');

	// === Bind resize & scroll events ===
	$(window).on('resize', function() {
		setEqualHeights('.how-it-works-wrapper');
		setEqualHeights('.team-section-wrapper');
	});

	$(window).on('scroll resize', function() {
		updateDotPosition('.how-it-works-wrapper');
		updateDotPosition('.team-section-wrapper');
	});


	$('#loadMoreFaqs button').on('click', function(e) {
		e.preventDefault();

		// Show hidden FAQ items
		var $hiddenFaqs = $('.faq-hidden.d-none');

		// Optionally, reveal in batches of 4
		var itemsToShow = 4;
		$hiddenFaqs.slice(0, itemsToShow).removeClass('d-none');

		// If no more hidden FAQs, hide the Load More button
		if ($('.faq-hidden.d-none').length === 0) {
			$('#loadMoreFaqs').fadeOut();
		}
	});


	$('.burger-menu-trigger').on('click', function(e) {
		e.preventDefault();

		$('.mobile-dropdown-wrapper').toggleClass('burger-active');

		if ($('.mobile-dropdown-wrapper').hasClass('burger-active')) {
			$('body').css('overflow', 'hidden');
			$('#wrapper-navbar').removeClass('scroll-active');
			$('#wrapper-navbar').addClass('burber-menu-active');
			$('.burger-menu-trigger').addClass('trigger-active');
		} else {
			$('body').css('overflow', '');
			$('#wrapper-navbar').removeClass('burber-menu-active');
			$('.burger-menu-trigger').removeClass('trigger-active');
			$('#wrapper-navbar').addClass('scroll-active');
		}
	});

	$('.share-trigger').on('click', function(e) {
		$('.share-wrapper').toggleClass('visible');
	});


	function setCookie(name, value) {
		document.cookie = name + "=" + value + "; path=/";
	}

	function getCookie(name) {
		let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		return match ? match[2] : null;
	}

	// Show popup if no cookie exists
	if (!getCookie('ctaPopupDismissed')) {
		$('#cta-popup').addClass('active');
	}

	// On dismiss
	$('#dismiss_cta').on('click', function(e) {
		e.preventDefault();
		$('#cta-popup').removeClass('active');
		setCookie('ctaPopupDismissed', 'true');
	});

	function setEqualHeightsRepeater() {
		$('.equal-height-wrapper').each(function() {
			var $wrapper = $(this);
			var $items = $wrapper.find('.equal-item');

			// Reset heights before recalculating
			$items.css('height', 'auto');

			// Find the tallest item
			var maxHeight = 0;
			$items.each(function() {
				var itemHeight = $(this).outerHeight();
				if (itemHeight > maxHeight) {
					maxHeight = itemHeight;
				}
			});

			// Apply the tallest height to all
			$items.css('height', maxHeight + 'px');
		});
	}

	// Run on load and resize
	setEqualHeightsRepeater();
	$(window).on('resize', function() {
		setEqualHeightsRepeater();
	});

	$('.related-blogs-slider').slick({
		slidesToShow: 2,   // whole number
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: true,
		prevArrow: $('.related-section-slider-prev'),
		nextArrow: $('.related-section-slider-next'),
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.body-comp-downloads-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: true,
		prevArrow: $('.downloads-section-slider-prev'),
		nextArrow: $('.downloads-section-slider-next'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			}
		]
	});

	$('.bone-dencity-downloads-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		arrows: true,
		prevArrow: $('.downloads-section-slider-prev'),
		nextArrow: $('.downloads-section-slider-next'),
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 1 }
			}
		]
	});

	function setDownloadItemEqualHeight(containerSelector) {
		var $container = $(containerSelector);
		var $items = $container.find('.download-item');
		var maxHeight = 0;

		$items.css('height', 'auto');

		$items.each(function() {
			var itemHeight = $(this).outerHeight();
			if (itemHeight > maxHeight) {
				maxHeight = itemHeight;
			}
		});

		$items.css('height', maxHeight + 'px');
	}

	function initEqualHeights() {
		setDownloadItemEqualHeight('.body-comp-downloads-slider');
		setDownloadItemEqualHeight('.bone-dencity-downloads-slider');
	}

	// Run on page load
	initEqualHeights();

	// Re-run on resize
	$(window).on('resize', function() {
		initEqualHeights();
	});

	// Run after Slick init
	$('.body-comp-downloads-slider, .bone-dencity-downloads-slider').on('init', function() {
		initEqualHeights();
	});

	// Existing click logic
	$('.grid-mobile .methods-comparison-grid .repeater-inner').on('click', function(e) {
		const $this = $(this);
		const $content = $this.find('.content-wrapper');
		const $plusIcon = $this.find('.fa-plus');
		const $xmarkIcon = $this.find('.fa-xmark');

		// Toggle visibility of content
		$content.toggleClass('visible');

		// Toggle icon visibility
		$plusIcon.toggleClass('d-none');
		$xmarkIcon.toggleClass('d-none');
	});

	$('.bone-density-hero-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		prevArrow: $('.bone-density-hero-slider-prev'),
		nextArrow: $('.bone-density-hero-slider-next'),
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 4000,
		fade: true,
		cssEase: 'ease-in-out'
	});

	$('.preview-content-trigger').on('click', function () {

		const parent = $(this).closest('.row');

		parent.find('.expand-content').slideToggle();

		$(this).toggleClass('open');
	});

	$('.logo-carousel.slick-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 8000,
		arrows: false,
		dots: false,
		infinite: false,
		variableWidth: true
	});

	$('.global-logo-carousel.slick-slider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 5000,
		cssEase: 'linear',
		arrows: false,
		dots: false,
		infinite: true,
		variableWidth: true,
		pauseOnHover: false,
		pauseOnFocus: false,
		swipe: false,
		draggable: false,
		loop: true,
	});



	// =============================
	// BACKGROUND VIMEO PLAYER
	// =============================
	let bgPlayers = [];

	document.querySelectorAll('.ppc-video[src*="vimeo"]').forEach(iframe => {
		bgPlayers.push(new Vimeo.Player(iframe));
	});


	// =============================
	// OPEN MODAL
	// =============================
	document.querySelectorAll(".custom-play-overlay").forEach(btn => {

		btn.addEventListener("click", function () {

			const modalId = this.dataset.modal;
			const type = this.dataset.type;
			const id = this.dataset.id;

			const modal = document.getElementById(modalId);
			const iframe = modal.querySelector(".modal-iframe");

			// Show modal first
			modal.style.display = "flex";

			// Pause background videos
			bgPlayers.forEach(player => player.pause());

			if (type === "youtube") {
				// YouTube autoplay + unmute
				iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=0&controls=1`;
			}

			if (type === "vimeo") {
				// Start muted (autoplay allowed)
				iframe.src = `https://player.vimeo.com/video/${id}?autoplay=1&muted=1`;

				const player = new Vimeo.Player(iframe);

				// Since the user clicked the overlay, we can unmute immediately
				player.setVolume(1).then(() => {
					console.log("Vimeo unmuted");
				}).catch(() => {
					console.log("Autoplay with sound blocked by Chrome, will require click to unmute");
					// Optional fallback: listen for first user click
					modal.addEventListener("click", function unmuteOnClick() {
						player.setVolume(1);
						modal.removeEventListener("click", unmuteOnClick);
					});
				});
			}

		});

	});


	// =============================
	// CLOSE MODALS
	// =============================
	document.querySelectorAll(".modal-close").forEach(closeBtn => {

		closeBtn.addEventListener("click", function () {

			const modal = this.closest(".video-modal");
			const iframe = modal.querySelector(".modal-iframe");

			modal.style.display = "none";
			iframe.src = "";

			// Resume background videos
			bgPlayers.forEach(player => player.play());

		});

	});


	// =============================
	// CLOSE ON BACKDROP CLICK
	// =============================
	document.querySelectorAll(".video-modal").forEach(modal => {

		modal.addEventListener("click", function (e) {

			if (e.target === modal) {

				const iframe = modal.querySelector(".modal-iframe");

				modal.style.display = "none";
				iframe.src = "";

				bgPlayers.forEach(player => player.play());
			}

		});

	});



	$(function () {
		if (sessionStorage.getItem('bannerClosed') === 'true') {
			$('#wrapper-navbar').removeClass('banner-open');
		} else {
			$('.banner-wrapper').addClass('banner-visible');
			$('#wrapper-navbar').addClass('banner-open');
		}

		$('.banner-close').on('click', function () {
			$('.banner-wrapper').slideUp(300, function () {
				$(this).removeClass('banner-visible').css('display', '');
				$('#wrapper-navbar').removeClass('banner-open');
			});
			sessionStorage.setItem('bannerClosed', 'true');
		});
	});



	function equalClinicTrialHeights() {

		const $items = $('.clinic-trial .clinic-trial-content');

		if (!$items.length) {
			return;
		}

		let maxHeight = 0;

		$items.css('height', 'auto');

		$items.each(function () {
			maxHeight = Math.max(maxHeight, $(this).outerHeight());
		});

		$items.css('height', maxHeight + 'px');
	}

	$(window).on('load', function () {
		setTimeout(equalClinicTrialHeights, 300);
	});

	$(window).on('resize', equalClinicTrialHeights);

	$(document).on('almComplete', function () {
		setTimeout(equalClinicTrialHeights, 50);
	});



	(function () {
		var $sliders  = $('.comparison-slider');
		var wrapperEl = document.querySelector('.dexa-london-table-wrapper');

		if (!$sliders.length || !wrapperEl) return;

		// --- Init / refresh each slider instance independently ---
		function initOrRefreshSliders() {
			var wrapperWidth = wrapperEl.getBoundingClientRect().width;
			if (wrapperWidth === 0) return; // still hidden, ResizeObserver will retry

			$sliders.each(function () {
				var $slider = $(this);
				var slideCount = $slider.children().length;

				if ($slider.hasClass('slick-initialized')) {
					$slider.slick('setPosition');
					return;
				}

				$slider.slick({
					slidesToShow: Math.min(1, slideCount),
					slidesToScroll: 1,
					infinite: false,
					arrows: true,
					dots: false,
					speed: 400,
					adaptiveHeight: false,
					swipeToSlide: true,
					touchThreshold: 10,
					mobileFirst: true,
					responsive: [
						{
							breakpoint: 992,
							settings: {
								slidesToShow: Math.min(3, slideCount),
								slidesToScroll: 1
							}
						}
					]
				});

				$slider.toggleClass('dct-no-nav', slideCount <= 3);
			});

			setTimeout(equalizeRowHeights, 60); // after Slick's own width/layout settles
		}

		// --- Match every row's height across labels, DEXA column(s), and every slide ---
		function equalizeRowHeights() {
			var $labelCells = $('.dct-labels .dct-cell');
			var rowCount = $labelCells.length;

			// Reset first, so we measure natural content height at the current width,
			// not a stale height left over from a previous (narrower/wider) layout
			$('.dct-cell').css('min-height', '');

			for (var i = 0; i < rowCount; i++) {
				var $rowCells = $('.dct-cell.dct-row-' + i); // matches labels, both DEXA cols, every slide
				var maxHeight = 0;

				$rowCells.each(function () {
					var h = this.getBoundingClientRect().height;
					if (h > maxHeight) maxHeight = h;
				});

				if (maxHeight > 0) {
					$rowCells.css('min-height', maxHeight + 'px');
				}
			}
		}

		// --- Visibility trigger (d-none removal, tabs, accordions, anything) ---
		var resizeObserver = new ResizeObserver(function () {
			initOrRefreshSliders();
		});
		resizeObserver.observe(wrapperEl);

		$(document).ready(function () {
			initOrRefreshSliders();
		});

		// Re-check after webfonts finish loading — text can reflow and change
		// row heights after the initial measurement
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(equalizeRowHeights);
		}

		// Breakpoint changes (desktop ⇄ mobile set swap) and window resize
		var resizeTimer;
		$(window).on('resize', function () {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				$sliders.each(function () {
					if ($(this).hasClass('slick-initialized')) {
						$(this).slick('setPosition');
					}
				});
				equalizeRowHeights();
			}, 150);
		});

		// Fires when Slick itself switches responsive breakpoints (e.g. slidesToShow changes)
		$sliders.on('breakpoint', function () {
			setTimeout(equalizeRowHeights, 60);
		});
	})();

});
